/*
    26/02/2020 - 1
    Initial version to force logout.

    07/05/2020 - 2
    Fixes to refresh token creation

    22/05/2020 - 3
    Business updates

    31/05/2020 - 4
    UUID Normalization

    10/07/2020 - 5
    unlock the LogRocket user info

    21/07/2020 - 6
    Re-jig deployments in auth for deployment attributes.

    13/08/2020 - 7
    Agency and Deployments move

    28/08/2020 - 8
    Deployment
    
    07/09/2020 - 9
    Deployment

    11/09/2020 - 10
    Migrate Rounds reducer to apiModelReducer

    21/09/2020 - 11
    Multiple rounds per product/description

    22/09/2020 - 12
    Standalone drafting information

    22/10/2020 - 13
    Restricted Business Views

    03/11/2020 - 14
    Melbourne Cup Day

    06/11/2020 - 15
    Sell files moved

    19/11/2020 - 16
    Offline properties

    04/12/2020 - 17
    Agency groups exposed

    28/04/2021 - 18
    Pens and scans rework

    01/11/2021 - 19
    Permissions and AgGrid Views

    30/11/2021 - 20
    AgGrid Saved Views

    14/01/2022 - 21
    Move sales to byId

    27/04/2022 - 22
    Login machinery updated.

    07/06/2022 - 23
    Security trimmed main navigation tabs.

    17/09/2022 - 24
    Many things - adjusted saga definitions, logrocket mis-identification, 401 management

    17/09/2022 - 25
    logrocket mis-identification

    15/12/2022 - 26
    Permissions being changed by shaun

    19/01/2022 - 27
    Scanning URL updates from Receival Scanning.

    19/12/2023 - 28
    URL Updates (re)moving saleyard from some places

*/

export const VERSION = 28;
